import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {AdminQuizPage} from "./AdminQuizPage";
import {AdminQuizzesList} from "./AdminQuizzesList";
import {AdminQuizBooleanQuestionPage} from "./Question/AdminQuizBooleanQuestionPage";
import {AdminQuizSingleChoiceQuestionPage} from "./Question/AdminQuizSingleChoiceQuestionPage";
import {AdminQuizMultipleChoiceQuestionPage} from "./Question/AdminQuizMultipleChoiceQuestionPage";

const useStyles = makeStyles()((theme) => ({
	adminQuizzesPage: {
	}
}));

export const AdminQuizzesPage: FC = () => {
	const {classes} = useStyles();

	return (
		<Box className={classes.adminQuizzesPage}>
			<Routes>
				<Route index element={<AdminQuizzesList />}/>
				<Route path="question/boolean-choice-question" element={<AdminQuizBooleanQuestionPage />} />
				<Route path="question/boolean-choice-question/:questionId" element={<AdminQuizBooleanQuestionPage />} />

				<Route path="question/single-choice-question" element={<AdminQuizSingleChoiceQuestionPage />} />
				<Route path="question/single-choice-question/:questionId" element={<AdminQuizSingleChoiceQuestionPage />} />

				<Route path="question/multiple-choice-question" element={<AdminQuizSingleChoiceQuestionPage />} />
				<Route path="question/multiple-choice-question/:questionId" element={<AdminQuizMultipleChoiceQuestionPage />} />

				<Route path="create" element={<AdminQuizPage />} />
				<Route path=":quizId" element={<AdminQuizPage />} />
			</Routes>
		</Box>
	);
}